/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum FrameType {
  /**
   * Lyricist/Text writer.
   */
  META_TAG_TEXT_TYPE = 'TEXT',
  /**
   * User defined text information frame.
   */
  META_TAG_USER_DEFINED_TEXT_TYPE = 'TXXX',
  /**
   * Title/Song name/Content description.
   */
  META_TAG_TITLE_TYPE = 'TIT2',
  /**
   * Album/Movie/Show title.
   */
  META_TAG_ALBUM_TYPE = 'TALB',
  /**
   * Original artist(s)/performer(s).
   */
  META_TAG_ARTIST_TYPE = 'TOPE',
  /**
   * The 'Date' frame is a numeric string in the DDMM format containing
   * the date for the recording.
   * <br></br>
   * This field is always four characters long.
   * <br></br>
   * Version ID3v2.3.0 only.
   */
  META_TAG_DATE_TYPE = 'TDAT',
  /**
   * TODO
   */
  META_TAG_SESSION_INFO_TYPE = 'SESSION_INFO',

  /**
   * Track number/position in set.
   */
  META_TAG_TRACK_NUM_TYPE = 'TRCK',

  /**
   * The 'Year' frame is a numeric string with a year of the recording.
   * <br></br>
   * This frames is always four characters long (until the year 10000).
   * <br></br>
   * Version ID3v2.3.0 only.
   */
  META_TAG_YEAR_TYPE = 'TYER',
  /**
   * Synchronised lyric/text.
   */
  META_TAG_LYRIC_TYPE = 'SYLT',
  /**
   * Comments.
   */
  META_TAG_COMMENTS_TYPE = 'COMM',
  /**
   * Private frame.
   */
  META_TAG_PRIVATE_FRAME_TYPE = 'PRIV',
  /**
   * Attached picture.
   */
  META_TAG_PICTURE_TYPE = 'APIC',
  /**
   * General encapsulated object.
   */
  META_TAG_GEOB_TYPE = 'GEOB',
  /**
   * Any other (custom) type that is not listed above.
   */
  META_TAG_BINARY_TYPE = 'BINARY',
  /**
   * Event Message (emsg) as defined in ISO 23009-1.
   */
  META_TAG_EMSG_TYPE = 'EMSG',
  /**
   * User defined URL link frame.
   */
  META_TAG_URL_LINK_TYPE = 'WXXX',
  /**
   * Chapter Information frame.
   */
  META_TAG_CHAPTER_TYPE = 'CHAP',
  /**
   * Chapter Table of Contents frame.
   */
  META_TAG_CHAPTER_TOC_TYPE = 'CTOC',
}
